// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type EllipsisIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from ellipsis.svg
 */
export default function EllipsisIcon(props: EllipsisIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="EllipsisIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M2 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m8 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
        />
      </g>
    </svg>
  );
}
